module.exports = __webpack_public_path__ + "img/chromecast_webcast_art.439f536.png";